export default "__VITE_ASSET__BsgmpbJI__"